/**
 * @generated SignedSource<<3647c54b8a62f24207cc9f3a5f817882>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HotelImportsTableRefetchQuery$variables = {
  after?: string | null;
  first: number;
};
export type HotelImportsTableRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HotelImportsTable_data">;
};
export type HotelImportsTableRefetchQuery = {
  response: HotelImportsTableRefetchQuery$data;
  variables: HotelImportsTableRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HotelImportsTableRefetchQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "HotelImportsTable_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HotelImportsTableRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          }
        ],
        "concreteType": "HotelImportConnection",
        "kind": "LinkedField",
        "name": "hotelImports",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HotelImportEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HotelImport",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRows",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currentRow",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hotelsImported",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "total",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "17c9e8db6ddf4b95cd850d5fc9080f1d",
    "id": null,
    "metadata": {},
    "name": "HotelImportsTableRefetchQuery",
    "operationKind": "query",
    "text": "query HotelImportsTableRefetchQuery(\n  $after: String\n  $first: Int!\n) {\n  ...HotelImportsTable_data\n}\n\nfragment HotelImportStatus_hotelImport on HotelImport {\n  status\n}\n\nfragment HotelImportsTableRow_import on HotelImport {\n  id\n  totalRows\n  currentRow\n  hotelsImported\n  createdAt\n  updatedAt\n  ...HotelImportStatus_hotelImport\n}\n\nfragment HotelImportsTable_data on Query {\n  hotelImports(first: $first, after: $after) {\n    edges {\n      node {\n        id\n        ...HotelImportsTableRow_import\n      }\n    }\n    pageInfo {\n      ...Table_pageInfo\n    }\n  }\n}\n\nfragment TablePagination_pageInfo on PageInfo {\n  total\n}\n\nfragment Table_pageInfo on PageInfo {\n  total\n  ...TablePagination_pageInfo\n}\n"
  }
};
})();

(node as any).hash = "ce571c0184d32d8580dafb2bb20c7bd9";

export default node;
